// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-dropzone{width:100%;padding:20px;margin:10px 0;border-width:2px;border-radius:2px;border-color:#eee;border-style:dashed;background-color:#fafafa;cursor:pointer;text-align:center}.file-link{cursor:pointer}", ""]);
// Exports
module.exports = exports;
